<div class="bmark-summary__fwd-risk__container">
  <div
    style="display: flex; flex-direction: row; align-items: stretch"
    class="bmark-summary__fwd-risk__body"
  >
    <bmark-fwd-risk-blotter
      style="display: flex; flex-direction: column; flex: 1 1 auto"
      #bmarkRiskView
      [publishGridDataUpdateInfo]="true"
      [fixingName]="fixing"
      [riskFilter]="riskFilter"
    >
    </bmark-fwd-risk-blotter>
  </div>
</div>
